<template>
  <div class="home">
    <div id="qyejz">
      <div class="banner_xszn">
        <div class="header_xszn_main">
          <div class="header_xszn">
            <div class="header_xszn_l">
              <h2></h2>
              <h4>咨询热线：<span>0351-6066360</span></h4>
            </div>
            <div class="header_xszn_r">
              <div class="header_xszn_jszn" >
<!--                <a href="">立即注册</a>-->
<!--                <span>|</span>-->
<!--                <a href="">登录</a>-->
<!--                <span>|</span>-->
                <a href="http://zkxejz.csfw360.com" class="a_other">首页</a>
              </div>
<!--              <div class="header_xszn_jszn_dl">-->
<!--                <a href="" class="a_my_gzt">我的工作台</a>-->
<!--                <p>zhangmimi</p>-->
<!--                <a href="">【退出】</a>-->
<!--                <span>|</span>-->
<!--                <a href="">首页</a>-->
<!--              </div>-->
            </div>
          </div><!--header_xszn-->
        </div><!--header_xszn_main-->
      </div><!--banner_xszn-->
      <div class="xszn_nav">
        <ul>
          <li><router-link to="/xszn" class="on">新手指南</router-link></li>
          <li><router-link to="/czzn">操作指南</router-link></li>
          <li><router-link to="/spxx">视频学习</router-link></li>
          <li><router-link to="/cjwt">常见问题</router-link></li>
        </ul>
      </div><!--xszn_nav-->
      <div class="wrap_xszn_main">
        <router-view />
      </div><!--wrap_xszn_main-->
      <div class="footer_guide_main">
        <div class="footer_guide">
          <h2><a href=""></a></h2>
          <p>山西众可信财税科技有限公司&nbsp;&nbsp;&nbsp;&nbsp;©版权所有&nbsp;&nbsp;&nbsp;&nbsp;联系地址：太原市羊市街鑫茂大厦五层&nbsp;&nbsp;&nbsp;&nbsp;邮编：030000&nbsp;&nbsp;&nbsp;&nbsp;备案号：晋ICP备11001348号-2</p>
        </div>
      </div>
<!--      <div class="popup_fixed">-->
<!--        <ul class="ul_1">-->
<!--          <li>-->
<!--            <a href="" class="popup_dh"></a>-->
<!--            <div class="popup_box">-->
<!--              <div class="box_dh_xx">-->
<!--                <img src="@/assets/images/icon_box_dh.png" alt="" />-->
<!--                <p>想了解更多 欢迎拨打热线<br /><i>400-6644-360</i></p>-->
<!--              </div>-->
<!--              <div class="box_dh_btn"><a href="">在线咨询</a><a href="" class="a_other">免费试用</a></div>-->
<!--            </div>-->
<!--          </li>-->
<!--          <span></span>-->
<!--          <li><a href="" class="popup_zxkf"></a></li>-->
<!--        </ul>-->
<!--        <ul class="ul_2">-->
<!--          <li>-->
<!--            <a href="" class="popup_ewm"></a>-->
<!--            <div class="popup_box">-->
<!--              <div class="box_ewm">-->
<!--                <h4>普及财税知识  分享财税生活</h4>-->
<!--                <ul>-->
<!--                  <li>-->
<!--                    <img src="@/assets/images/icon_box_ewm_wx.png" alt="" />-->
<!--                    <p>请使用微信扫一扫</p>-->
<!--                  </li>-->
<!--                  <li>-->
<!--                    <img src="@/assets/images/icon_box_ewm_dy.png" alt="" />-->
<!--                    <p>请使用抖音扫一扫</p>-->
<!--                  </li>-->
<!--                </ul>-->
<!--              </div>-->
<!--            </div>-->
<!--          </li>-->
<!--          <em></em>-->
<!--          <li><a href="javascript:void(0);" @click="pageScroll" class="popup_gotop"></a></li>-->
<!--        </ul>-->
<!--      </div>&lt;!&ndash;popup_fixed&ndash;&gt;-->
    </div><!--qyjz-->
  </div>
</template>

<script>
export default {
  name: 'Home',
  methods: {
    pageScroll() {
      const scrolldelay = setTimeout(() => {
        window.scrollBy(0, -100);
        const sTop = document.documentElement.scrollTop + document.body.scrollTop;
        if (sTop === 0) {
          clearTimeout(scrolldelay);
        }
      }, 20);
    },
  },
};
</script>
